"use client";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import Image from "next/image";
import type { ContentImage } from "@/types/contentful/ContentImage";

interface Props {
  image: ContentImage;
  priority?: boolean;
  entryId?: string;
  sizes?: string;
}

export const SingleImage = ({
  image,
  priority = false,
  entryId,
  sizes = "(min-width: 1024px) 690px, 100vw",
}: Props) => {
  const inspectorProps = useContentfulInspectorMode();
  return (
    <div
      className="relative mx-auto w-full aspect-square max-h-125 max-w-125 overflow-hidden rounded-md"
      {...(entryId ? inspectorProps({ entryId, fieldId: "media" }) : {})}
    >
      <Image src={image.src} alt={image.alt} fill className="object-cover" sizes={sizes} priority={priority} />
    </div>
  );
};
